import { useTranslation } from 'react-i18next';
import { PricingModelDetails } from '../../../PricingModelDetails/PricingModelDetails';
import { SideBarFooter } from '../../components';
import { InvoiceTabsProps, setFooterData } from '../InvoicesSideBar.utils';
import styles from './InvoiceDetails.module.scss';

export const InvoiceDetails = ({ invoiceData, invoiceDetailsProps }: InvoiceTabsProps) => {
	const { t } = useTranslation('translation');

	const { hasUsageReport, onPressUpdateUsage } = invoiceDetailsProps;

	return (
		<div className={styles.tabsSection}>
			<div className={styles.container}>
				<div className={styles.header}>
					<span className={styles.subTitle}>{t('relatedProducts')}</span>
				</div>

				<div className={styles.cards}>
					{invoiceData?.pricingModel?.tabs?.map((tab, index) => (
						<PricingModelDetails
							key={index}
							data={tab}
							supplier={invoiceData?.supplier}
							hasUsageReport={hasUsageReport}
							fromDate={tab.billingStartDate}
							toDate={tab.billingEndDate}
							onPressUpdateUsage={() =>
								onPressUpdateUsage?.({
									fromDate: tab?.billingStartDate || null,
									toDate: tab?.billingEndDate || null,
								})
							}
						/>
					))}
				</div>
			</div>

			<SideBarFooter items={setFooterData(invoiceData)} className={styles.footer} />
		</div>
	);
};
